<template>
    <div class="upsell-page">
        <div class="upsell-page__header">
            <div class="upsell-page__header-logo" @click="goToUrl('/home')">
                <CompassLogo type="logo" :width="160" />
            </div>
        </div>

        <div class="upsell-page__content">
            <div class="upsell-page__content-illustration">
                <img src="/ressources/logged/img/illustrations/services-upgrade.svg" />
            </div>

            <div class="upsell-page__content-title typographies-display-large">
                {{ $l10n.__('Passez à la vitesse supérieure !') }}
            </div>

            <div class="upsell-page__content-informations typographies-paragraph-x-large-regular">
                {{
                    $l10n.__(
                        'Pour utiliser la fonctionnalité à laquelle vous souhaitez accéder, vous devez passer au plan supérieur.',
                    )
                }}
            </div>

            <div class="upsell-page__content-buttons">
                <CompassButton
                    :label="$t.__('common.actions.contact_sales')"
                    size="large"
                    @click="contactASale"
                />
                <CompassLink
                    :label="$t.__('pages.UpsellPage.back_dashboard')"
                    link="/home"
                    size="large"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';

export default {
    methods: {
        goToUrl,
        contactASale() {
            window.Intercom('show');
        },
    },
};
</script>

<style lang="scss" scoped>
.upsell-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    &__header {
        align-self: flex-start;

        &-logo {
            cursor: pointer;
        }
    }

    &__content {
        margin: auto;

        &-illustration {
            text-align: center;
            margin-bottom: var(--spacing-5);
            > img {
                border-radius: 24px;
            }
        }

        &-title {
            text-align: center;
            color: var(--colors-common-text-brand-secondary-blue);
            margin-bottom: var(--spacing-3);
        }

        &-informations {
            text-align: center;
            color: var(--colors-common-text-subtle-default);
            margin-bottom: var(--spacing-5);
        }

        &-buttons {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: var(--spacing-4);
        }
    }
}
</style>
